module.exports = __webpack_public_path__ + "static/media/marketing-hub.b31c4f32.svg";